import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, ListingCard } from '../../components';

import css from './ListingPage.module.css';

/**
 * "More from {artist}" — other published works by the same artist.
 * Renders nothing when the artist has no other works (the common case for a
 * curated single-piece consignment), so it never shows an empty shell.
 */
const SectionRelatedListings = props => {
  const { relatedListings = [], artistName } = props;

  if (!relatedListings || relatedListings.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionRelated}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.relatedListingsTitle" values={{ artist: artistName }} />
      </Heading>
      <ul className={css.relatedList}>
        {relatedListings.map(l => (
          <li className={css.relatedItem} key={l.id.uuid}>
            <ListingCard listing={l} showAuthorInfo={false} />
          </li>
        ))}
      </ul>
    </section>
  );
};

export default SectionRelatedListings;
